/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tap_To_Open_In_The_InteractiveInputs */

const en_tap_to_open_in_the_interactive = /** @type {(inputs: Tap_To_Open_In_The_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to open in the interactive reader`)
};

const es_tap_to_open_in_the_interactive = /** @type {(inputs: Tap_To_Open_In_The_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca para abrir en el lector interactivo`)
};

const fr_tap_to_open_in_the_interactive = /** @type {(inputs: Tap_To_Open_In_The_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appuyez pour ouvrir dans la liseuse interactive`)
};

const de_tap_to_open_in_the_interactive = /** @type {(inputs: Tap_To_Open_In_The_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippen, um im interaktiven Reader zu öffnen`)
};

const ja_tap_to_open_in_the_interactive = /** @type {(inputs: Tap_To_Open_In_The_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タップしてインタラクティブリーダーで開く`)
};

const zh_tap_to_open_in_the_interactive = /** @type {(inputs: Tap_To_Open_In_The_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击以在交互式阅读器中打开`)
};

const ar_tap_to_open_in_the_interactive = /** @type {(inputs: Tap_To_Open_In_The_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اضغط للفتح في القارئ التفاعلي`)
};

const id_tap_to_open_in_the_interactive = /** @type {(inputs: Tap_To_Open_In_The_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketuk untuk membuka di pembaca interaktif`)
};

const it_tap_to_open_in_the_interactive = /** @type {(inputs: Tap_To_Open_In_The_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tocca per aprire nel lettore interattivo`)
};

const ru_tap_to_open_in_the_interactive = /** @type {(inputs: Tap_To_Open_In_The_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нажмите, чтобы открыть в интерактивном ридере`)
};

const pt_tap_to_open_in_the_interactive = /** @type {(inputs: Tap_To_Open_In_The_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque para abrir no leitor interativo`)
};

const ko_tap_to_open_in_the_interactive = /** @type {(inputs: Tap_To_Open_In_The_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`탭하여 인터랙티브 리더에서 열기`)
};

/**
* | output |
* | --- |
* | "Tap to open in the interactive reader" |
*
* @param {Tap_To_Open_In_The_InteractiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tap_to_open_in_the_interactive = /** @type {((inputs?: Tap_To_Open_In_The_InteractiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tap_To_Open_In_The_InteractiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tap_to_open_in_the_interactive(inputs)
	if (locale === "es") return es_tap_to_open_in_the_interactive(inputs)
	if (locale === "fr") return fr_tap_to_open_in_the_interactive(inputs)
	if (locale === "de") return de_tap_to_open_in_the_interactive(inputs)
	if (locale === "ja") return ja_tap_to_open_in_the_interactive(inputs)
	if (locale === "zh") return zh_tap_to_open_in_the_interactive(inputs)
	if (locale === "ar") return ar_tap_to_open_in_the_interactive(inputs)
	if (locale === "id") return id_tap_to_open_in_the_interactive(inputs)
	if (locale === "it") return it_tap_to_open_in_the_interactive(inputs)
	if (locale === "ru") return ru_tap_to_open_in_the_interactive(inputs)
	if (locale === "pt") return pt_tap_to_open_in_the_interactive(inputs)
	return ko_tap_to_open_in_the_interactive(inputs)
});